import { render, staticRenderFns } from "./Navebar.vue?vue&type=template&id=1880466a&scoped=true&"
import script from "./Navebar.vue?vue&type=script&lang=js&"
export * from "./Navebar.vue?vue&type=script&lang=js&"
import style0 from "./Navebar.vue?vue&type=style&index=0&id=1880466a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880466a",
  null
  
)

export default component.exports